import { DraftLead } from '@user/store/draftLeads'
import { useMemo } from 'react'
import { getFormattedAddress } from '@sales-center/common'

interface Props {
  lead: DraftLead
}

export function useData(props: Props) {
  const { lead } = props

  const formattedAddress = useMemo(
    () =>
      getFormattedAddress(
        lead.street1 ?? '',
        lead.street2 ?? '',
        lead.city ?? '',
        lead.stateAbbreviation ?? '',
        lead.postalCode ?? '',
      ),
    [
      lead.city,
      lead.postalCode,
      lead.stateAbbreviation,
      lead.street1,
      lead.street2,
    ],
  )
  return { formattedAddress }
}
